import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { marquee as MarqueePropType } from 'lib/CustomPropTypes';
import { dismissMarquee as dismissMarqueeAction } from 'redux/modules/marquee';
import Breaking from './Breaking';
import Embed from './Embed';

const mapStoreToProps = ({
  article, marquee, router, shared,
}) => ({
  currentPath: router.path,
  isShellArticle: get(article, 'presentation.style', false) === 'shell',
  marquees: marquee.marquees,
  vertical: shared.vertical,
});

const mapActionsToProps = (dispatch) => ({
  dismissMarquee: () => dispatch(dismissMarqueeAction()),
});

function Marquee({
  currentPath, dismissMarquee, isShellArticle, marquees, vertical,
}) {
  // Hide on shell articles
  if (isShellArticle) {
    return null;
  }
  return (
    <>
      {marquees.map((marquee, index) => {
        const { marqueeType: type } = marquee;
        const key = `marquee-${index}`;
        // Embed marquee
        if (type === 'embed') {
          if (vertical !== 'today' || (vertical === 'today' && currentPath === '/')) {
            return (
              <Embed
                key={key}
                marquee={marquee}
              />
            );
          }
          return null;
        }
        // breakingNews, callOut, etc marquee
        if (type !== 'embed' && vertical !== 'knowyourvalue') {
          return (
            <Breaking
              key={key}
              marquee={marquee}
              dismissMarquee={dismissMarquee}
            />
          );
        }
        // Unsupported type?
        return null;
      })}
    </>
  );
}

Marquee.propTypes = {
  currentPath: PropTypes.string.isRequired,
  dismissMarquee: PropTypes.func.isRequired,
  isShellArticle: PropTypes.bool.isRequired,
  marquees: PropTypes.arrayOf(MarqueePropType).isRequired,
  vertical: PropTypes.string.isRequired,
};

export default connect(mapStoreToProps, mapActionsToProps)(Marquee);
